import React from 'react';

class ComponentsFileCopyList extends React.Component {
  getList() {
    const { selectReportIdForFileCopy, selectedReportId, components } = this.props;

    return (
      <div className='list__wrapper _margin_top_20'>
        <div className='list__row list__header list__header_small'>
          <div className='list__row-item list__header-item_small _width_pc_15'>ID</div>
          <div className='list__row-item list__header-item_small _width_pc_25'>Type</div>
          <div className='list__row-item list__header-item_small list__row-item_place-filler'>Description</div>
        </div>
        <div className='_max_height_vh_40 _overflow_x_auto'>
          {components.map((component, index) => (
            <div
              className={`list__row list__row_small list__row_selectable ${
                selectedReportId == component.id ? 'list__row_selected' : ''
              }`}
              key={index}
              onClick={() => {
                selectReportIdForFileCopy(component.id);
              }}
            >
              <div className='list__row-item list__row-item_small _width_pc_15'>{component.id}</div>
              <div className='list__row-item list__row-item_small _width_pc_25'>
                {component.componentType.componentTypeName}
              </div>
              <div className='list__row-item list__row-item_small list__row-item_place-filler'>
                {component.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  render() {
    return (
      <section className='_min_width_480'>
        <header>Copy Test Reports</header>
        <div className='_font_size_12 _font_weight_100 _color_light_gray _margin_bottom_10 _margin_top_20'>
          Select existing component to copy test reports from
        </div>
        {this.getList()}
      </section>
    );
  }
}

export default ComponentsFileCopyList;



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/Application/New/ComponentsFileCopyList.jsx